import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "meeting-popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = {
  key: 0,
  class: "dialogue"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "Your payment has failed to process", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "dialogue"
}
const _hoisted_7 = {
  key: 2,
  class: "dialogue"
}
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("You will ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z",
      fill: "#e23d35"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_12 = {
  key: 3,
  class: "dialogue"
}
const _hoisted_13 = { class: "text" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("You will ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" for ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M12 0C5.3868 0 0 5.3868 0 12C0 18.6132 5.3868 24 12 24C18.6132 24 24 18.6132 24 12C24 5.3868 18.6132 0 12 0ZM12 2.4C17.3161 2.4 21.6 6.68385 21.6 12C21.6 17.3161 17.3161 21.6 12 21.6C6.68385 21.6 2.4 17.3161 2.4 12C2.4 6.68385 6.68385 2.4 12 2.4ZM10.8 4.8V12.4969L15.9516 17.6484L17.6484 15.9516L13.2 11.5031V4.8H10.8Z",
      fill: "#e23d35"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_17 = { class: "meeting-note text-block" }
const _hoisted_18 = {
  key: 0,
  class: "icon-header"
}
const _hoisted_19 = { class: "user-icon" }
const _hoisted_20 = { class: "profile" }
const _hoisted_21 = {
  key: 0,
  class: "profile-container"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "profile-container"
}
const _hoisted_24 = { class: "profile-initials" }
const _hoisted_25 = {
  key: 2,
  class: "profile-container"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon profile",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    class: "filled",
    d: "M50 0C40 0 30.4 2.9 22.2 8.4C14 14 7.6 21.7 3.8 30.9C0 40 -0.97 50 0.96 59.7546C2.89002 69.4536 7.65222 78.3628 14.6449 85C21.6 92.3 30.5464 97 40 99C50 101 60 100 69.1 96.2C78.3 92.4 86 86.0 91.6 77.8C97.1 69.6 100 60 100 50C100 36.74 94.7263 24 85.3505 14.6497C75.9747 5.27383 63.2594 0.00454376 50 0M50 15C52.9667 15 55.8668 15.8797 58.3335 17.528C60.8003 19.1762 62.7231 21.5189 63.8584 24.2598C65 27.0007 65.2907 30.0166 64.7119 32.9264C64.1331 35.8361 62.7046 38.5089 60.6068 40.6066C58.509 42.7044 55.8362 44.1331 52.9265 44.7118C50.0168 45.29 47.0007 45 44.2598 43.8582C41.519 42.7229 39.1764 40.8003 37.5282 38.3336C35.88 35.8668 35 32.9668 35 30C35 28.0 35.3837 26.0777 36.1366 24.2567C36.8895 22.4356 38 20.7809 39.3875 19.3875C40.7809 18 42.4356 16.8893 44.2567 16.1364C46.0778 15.3836 48.0294 15 50 15M50 86C44.0592 86 38.2109 84.53 32.9764 81.7208C27.7418 78.9116 23.2838 74.85 20 69.9C20.1513 60 40 54.50 50 54.5C59.9485 54.50 79.8486 60 80 69.9C76.7 74.85 72.2584 78.9116 67.0239 81.7208C61.7894 84.53 55.9407 86 50 86"
  })
], -1 /* HOISTED */)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "user-header" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "meeting-header" }, "Meeting with ", -1 /* HOISTED */)
const _hoisted_30 = { class: "user-name" }
const _hoisted_31 = {
  key: 1,
  class: "description"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "text-block" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "description" }, "The Sender of this meeting had to reschedule")
], -1 /* HOISTED */)
const _hoisted_33 = { class: "text-block" }
const _hoisted_34 = { class: "meeting-location text-block" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "Location Details", -1 /* HOISTED */)
const _hoisted_36 = {
  key: 0,
  class: "description"
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("Video Link: ")
const _hoisted_38 = ["href"]
const _hoisted_39 = {
  key: 1,
  class: "description"
}
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Phone Number: ")
const _hoisted_41 = ["href"]
const _hoisted_42 = {
  key: 2,
  class: "description"
}
const _hoisted_43 = { class: "line" }
const _hoisted_44 = {
  key: 0,
  class: "line"
}
const _hoisted_45 = { class: "line" }
const _hoisted_46 = {
  key: 3,
  class: "description"
}
const _hoisted_47 = {
  key: 4,
  class: "description"
}
const _hoisted_48 = { class: "meeting-contact text-block" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "header" }, "How to get in touch", -1 /* HOISTED */)
const _hoisted_50 = { class: "description" }
const _hoisted_51 = {
  key: 5,
  class: "button-container"
}
const _hoisted_52 = {
  key: 6,
  class: "button-container"
}
const _hoisted_53 = {
  key: 7,
  class: "button-container"
}
const _hoisted_54 = { class: "manage" }
const _hoisted_55 = {
  key: 0,
  class: "manage-popup"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.90922 0.000179007C1.7464 0.000179007 1.58339 0.0622029 1.4593 0.186609L0.186609 1.4593C-0.062203 1.70812 -0.062203 2.11096 0.186609 2.35914L4.82747 7L0.186609 11.6409C-0.062203 11.8897 -0.062203 12.2925 0.186609 12.5407L1.4593 13.8134C1.70812 14.0622 2.11096 14.0622 2.35914 13.8134L7 9.17253L11.6409 13.8134C11.889 14.0622 12.2925 14.0622 12.5407 13.8134L13.8134 12.5407C14.0622 12.2919 14.0622 11.889 13.8134 11.6409L9.17253 7L13.8134 2.35914C14.0622 2.11096 14.0622 1.70748 13.8134 1.4593L12.5407 0.186609C12.2919 -0.062203 11.889 -0.062203 11.6409 0.186609L7 4.82747L2.35914 0.186609C2.23473 0.0622029 2.07205 0.000179007 1.90922 0.000179007Z",
    fill: "black"
  })
], -1 /* HOISTED */)
const _hoisted_57 = [
  _hoisted_56
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.showCheckIn)
      ? (_openBlock(), _createBlock($setup["CheckInPopup"], {
          key: 0,
          selectedMeeting: $props.selectedMeeting,
          onClosePopup: _cache[0] || (_cache[0] = ($event: any) => ($setup.showCheckIn = false)),
          onDeepClosePopup: _cache[1] || (_cache[1] = ($event: any) => {$setup.showCheckIn = false; $setup.closePopup()})
        }, null, 8 /* PROPS */, ["selectedMeeting"]))
      : _createCommentVNode("v-if", true),
    ($setup.showCancel)
      ? (_openBlock(), _createBlock($setup["CancelMeetingPopup"], {
          key: 1,
          selectedMeeting: $props.selectedMeeting,
          onClosePopup: _cache[2] || (_cache[2] = ($event: any) => ($setup.showCancel = false)),
          onDeepClosePopup: _cache[3] || (_cache[3] = ($event: any) => {$setup.showCancel = false; $setup.closePopup()}),
          onMoveToReschedule: $setup.moveToReschedule
        }, null, 8 /* PROPS */, ["selectedMeeting"]))
      : _createCommentVNode("v-if", true),
    ($setup.showPause)
      ? (_openBlock(), _createBlock($setup["RequestReschedulePopup"], {
          key: 2,
          selectedMeeting: $props.selectedMeeting,
          onClosePopup: _cache[4] || (_cache[4] = ($event: any) => ($setup.showPause = false)),
          onDeepClosePopup: _cache[5] || (_cache[5] = ($event: any) => {$setup.showPause = false; $setup.closePopup()})
        }, null, 8 /* PROPS */, ["selectedMeeting"]))
      : _createCommentVNode("v-if", true),
    ($setup.showReport)
      ? (_openBlock(), _createBlock($setup["ReportProblemPopup"], {
          key: 3,
          selectedMeeting: $props.selectedMeeting,
          onClosePopup: _cache[6] || (_cache[6] = ($event: any) => ($setup.showReport = false)),
          onDeepClosePopup: _cache[7] || (_cache[7] = ($event: any) => {$setup.showReport = false; $setup.closePopup()}),
          onMoveToReschedule: $setup.moveToReschedule
        }, null, 8 /* PROPS */, ["selectedMeeting"]))
      : _createCommentVNode("v-if", true),
    ($setup.showRunningLate)
      ? (_openBlock(), _createBlock($setup["RunningLatePopup"], {
          key: 4,
          selectedMeeting: $props.selectedMeeting,
          onClosePopup: _cache[8] || (_cache[8] = ($event: any) => ($setup.showRunningLate = false)),
          onDeepClosePopup: _cache[9] || (_cache[9] = ($event: any) => {$setup.showRunningLate = false; $setup.closePopup()}),
          onMoveToReschedule: $setup.moveToReschedule
        }, null, 8 /* PROPS */, ["selectedMeeting"]))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["CloseButton"], { onClickedClose: $setup.closePopup }),
    _createVNode($setup["DetailsHeader"], { meetingMoment: $setup.meetingMoment }, null, 8 /* PROPS */, ["meetingMoment"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["info-header", {'retry-payment': $setup.reconfirmPayment}])
      }, [
        ($setup.reconfirmPayment)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : ($setup.rescheduleRequested)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : ($setup.isPayingUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("span", null, "pay " + _toDisplayString($props.selectedMeeting.price.currency) + _toDisplayString($props.selectedMeeting.price.amount), 1 /* TEXT */),
                    _hoisted_10,
                    _createElementVNode("span", null, _toDisplayString($setup.meetingDuration) + " mins", 1 /* TEXT */)
                  ]),
                  _hoisted_11
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", null, "earn " + _toDisplayString($props.selectedMeeting.price.currency) + _toDisplayString($props.selectedMeeting.price.amount), 1 /* TEXT */),
                    _hoisted_15,
                    _createElementVNode("span", null, _toDisplayString($setup.meetingDuration) + " mins", 1 /* TEXT */)
                  ]),
                  _hoisted_16
                ]))
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_17, [
        ($setup.otherUser)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  ($setup.otherUser?.profilePic)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("img", {
                          class: "profile-pic",
                          src: $setup.otherUser.profilePic
                        }, null, 8 /* PROPS */, _hoisted_22)
                      ]))
                    : ($setup.otherUser?.name?.firstName && $setup.otherUser?.name?.lastName)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, _toDisplayString($setup.otherUser.name.firstName[0] + $setup.otherUser.name.lastName[0]), 1 /* TEXT */)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_27))
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString($setup.otherUser.name.fullName), 1 /* TEXT */)
              ])
            ]))
          : _createCommentVNode("v-if", true),
        (!$setup.rescheduleRequested)
          ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString($setup.personalMessage), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.rescheduleRequested)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createVNode($setup["TextField"], {
                class: "reschedule-details",
                label: "Details",
                placeholderText: $setup.rescheduleMessage,
                readOnly: ""
              }, null, 8 /* PROPS */, ["placeholderText"])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              ($props.selectedMeeting?.location?.type == 'video')
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("a", {
                      href: $props.selectedMeeting.location.fields.link,
                      target: "_blank"
                    }, _toDisplayString($props.selectedMeeting.location.fields.link), 9 /* TEXT, PROPS */, _hoisted_38)
                  ]))
                : ($props.selectedMeeting?.location?.type == 'phone')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("a", {
                        href: 'tel:'+$props.selectedMeeting.location.fields.number,
                        target: "_blank"
                      }, _toDisplayString($props.selectedMeeting.location.fields.number), 9 /* TEXT, PROPS */, _hoisted_41)
                    ]))
                  : ($props.selectedMeeting?.location?.type == 'physical')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, _toDisplayString($props.selectedMeeting.location.fields.street1), 1 /* TEXT */),
                        ($props.selectedMeeting.location.fields.street2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString($props.selectedMeeting.location.fields.street2), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("div", _hoisted_45, _toDisplayString($props.selectedMeeting.location.fields.city) + ", " + _toDisplayString($props.selectedMeeting.location.fields.state) + " " + _toDisplayString($props.selectedMeeting.location.fields.postal), 1 /* TEXT */)
                      ]))
                    : ($props.selectedMeeting?.location?.type == 'other')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString($props.selectedMeeting.location.fields.note), 1 /* TEXT */))
                      : (_openBlock(), _createElementBlock("div", _hoisted_47, "No Location information provided"))
            ]),
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _createElementVNode("div", _hoisted_50, _toDisplayString($setup.contactInfo), 1 /* TEXT */)
            ])
          ], 64 /* STABLE_FRAGMENT */))
    ]),
    ($setup.reconfirmPayment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("button", {
            class: "outline",
            onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showCancel = true))
          }, "Cancel Meeting"),
          _createElementVNode("button", {
            class: "primary",
            onClick: $setup.moveToRetryPage
          }, "Fix Payment")
        ]))
      : ($setup.rescheduleRequested)
        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
            _createElementVNode("button", {
              class: "primary",
              onClick: $setup.moveToReschedule
            }, "Reschedule Meeting"),
            _createElementVNode("button", {
              class: "outline",
              onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.showCancel = true))
            }, "Cancel Meeting")
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("button", {
                class: "outline",
                onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.manage = true))
              }, "Manage"),
              ($setup.manage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    ($setup.meetingNotFinished)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "outline",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => {$setup.showRunningLate = true; $setup.manage = false})
                        }, "I'm Running Late"))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      class: "outline",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => {$setup.showReport = true; $setup.manage = false})
                    }, "Report a Problem"),
                    ($setup.meetingReschedulable)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          class: "outline",
                          onClick: $setup.moveToReschedule
                        }, "Reschedule"))
                      : _createCommentVNode("v-if", true),
                    ($setup.meetingNotFinished)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          class: "outline",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => {$setup.showCancel = true; $setup.manage = false})
                        }, "Cancel Meeting"))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("div", {
                      class: "close-button",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => ($setup.manage = false))
                    }, _hoisted_57)
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            ($setup.meetingConfirmable)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "primary",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => {$setup.showCheckIn = true; $setup.manage = false})
                }, "Confirm Meeting"))
              : _createCommentVNode("v-if", true)
          ]))
  ]))
}